import { blacks } from './blacks';

const base = {
    '50': '#e5f0ff',
    '100': '#bedaff',
    '200': '#93c1ff',
    '300': '#67a8ff',
    '400': '#4796ff',
    '500': '#d6e8ff',
    '600': '#227bff',
    '700': '#1c70ff',
    '800': '#1766ff',
    '900': '#0d53ff'
};
const contrast = {
    '50': blacks[500],
    '100': blacks[500],
    '200': blacks[500],
    '300': blacks[500],
    '400': '#ffffff',
    '500': '#ffffff',
    '600': '#ffffff',
    '700': '#ffffff',
    '800': '#ffffff',
    '900': '#ffffff'
};

const alpha = {
    '50': base[50] + '1f',
    '100': base[100] + '1f',
    '200': base[200] + '1f',
    '300': base[300] + '1f',
    '400': base[400] + '1f',
    '500': base[500] + '1f',
    '600': base[600] + '1f',
    '700': base[700] + '1f',
    '800': base[800] + '1f',
    '900': base[900] + '1f'
};

export const blues = {
    '50': base[50],
    '100': base[100],
    '200': base[200],
    '300': base[300],
    '400': base[400],
    '500': base[500],
    '600': base[600],
    '700': base[700],
    '800': base[800],
    '900': base[900],
    light: base[50],
    medium: base[300],
    dark: base[500],
    contrast,
    alpha
};
